import React from 'react';
import { StyledStickyContainer } from './styled';

interface StickyContainerProps {
  children: React.ReactNode;
  top?: number;
  zIndex?: number;
  className?: string;
  backgroundColor?: string;
  showShadow?: boolean;
}

const StickyContainer: React.FC<StickyContainerProps> = ({
  children,
  top = 0,
  zIndex = 0,
  className = '',
  backgroundColor = '#e4e4e4',
}) => {
  return (
    <StyledStickyContainer
      top={top}
      zIndex={zIndex}
      className={className}
      backgroundColor={backgroundColor}
    >
      {children}
    </StyledStickyContainer>
  );
};

export default StickyContainer; 